import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";

const useVitalsStore = create(
  persist(
  devtools((set) => ({
    vitals: [],
    saveVitals: (vitals) => set({ vitals }),
  })),
  {
    name: 'vitalsStore',
  }
)
);

export default useVitalsStore